import { cn } from "@/lib/utils";

export interface BrandMarkProps {
  size?: number;
  className?: string;
}

export function BrandMark({ size = 26, className }: BrandMarkProps) {
  return (
    <span
      aria-label="Vroom"
      className={cn(
        "inline-flex items-center justify-center bg-vroom-red text-white",
        "shadow-[inset_0_1px_0_rgba(255,255,255,0.16),inset_0_-1px_0_rgba(0,0,0,0.08),0_1px_1px_rgba(120,8,16,0.10)]",
        "dark:shadow-[inset_0_1px_0_rgba(255,255,255,0.18),inset_0_-1px_0_rgba(0,0,0,0.20),0_1px_1px_rgba(0,0,0,0.35)]",
        className,
      )}
      style={{
        width: size,
        height: size,
        borderRadius: "var(--r-3)",
        fontFamily: "var(--font-display)",
        fontWeight: 700,
        fontSize: Math.round(size * 0.58),
        letterSpacing: "-.04em",
      }}
    >
      V
    </span>
  );
}
